export default __webpack_public_path__ + "static/media/+branco.ec2630bf.svg";